import { render, staticRenderFns } from "./shippingLable.vue?vue&type=template&id=f2b9ebd6&scoped=true"
import script from "./shippingLable.vue?vue&type=script&lang=js"
export * from "./shippingLable.vue?vue&type=script&lang=js"
import style0 from "./shippingLable.vue?vue&type=style&index=0&id=f2b9ebd6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b9ebd6",
  null
  
)

export default component.exports